export default __webpack_public_path__ + "static/media/views_icon.94c85324.svg";